module.exports = __webpack_public_path__ + "static/img/chejia_car_3.1f6eaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_car_3.png
// module id = W30V
// module chunks = 19